module.exports = __webpack_public_path__ + "static/media/Cal_BG.62e6dfb2.png";